<template>
  <div class="flex-column layout">
    <Header></Header>
    <div class="flex-column flex-rest content-wrap">
      <div class="flex flex-end login-info">
        <LoginLabel></LoginLabel>
      </div>
      <div class="flex content-middle">
        <SideBar></SideBar>
        <router-view class="flex-column content"></router-view>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";
import Header from "@/components/header/index.vue";
import SideBar from "@/components/sidebar/index.vue";
import Footer from "@/components/footer/index.vue";
import LoginLabel from "@/components/loginLabel/index.vue";
@Component({
  components: {
    Header,
    LoginLabel,
    SideBar,
    Footer
  }
})
export default class Layout extends Vue {}
</script>

<style lang="scss" scoped>
.layout {
  height: 100%;
  .login-info {
    margin: 58 * $percent 0;
    padding-right: 25px;
  }
  .content-wrap {
    width:1200px;
    // padding: 0 18%;
    margin: auto;
  }
  .content {
    flex: 1;
    // width: 1000px;
    // min-height: 100%;
  }
}
</style>
